import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'

import { useSelectedProjectStore } from '@/components/entities/common/model/selected-project.store'

import { RequestsService } from '../lib/requests.service'
import { RequestTypeType } from '../lib/requests.types'

export const REQUEST_TYPES = 'request-types'

export const useRequestTypes = () => {
  const { selectedProjectId } = useSelectedProjectStore()

  const { data, ...rest } = useQuery({
    queryKey: [REQUEST_TYPES, selectedProjectId],
    queryFn: () => RequestsService.getRequestTypes(selectedProjectId),
    enabled: Boolean(selectedProjectId)
  })

  const requestTypesByAlias = useMemo(
    () =>
      data?.data.reduce((acc: Record<string, RequestTypeType>, requestType) => {
        acc[requestType.alias] = requestType
        return acc
      }, {}),
    [data]
  )

  return {
    data: data?.data,
    requestTypesByAlias,
    arePassesAvailable: data?.arePassesAvailable,
    areRequestsAvailable: data?.areRequestsAvailable,
    ...rest
  }
}
